const getParamsFromUrl = () => {
    const url = window.location.href
    const paramsStr = url.split("?")[1] || ""
    let paramsStr1 = ""
    if (url.split("?")[2]) {
      paramsStr1 = url.split("?")[2]
    }
    let paramsArr = paramsStr.split("&")
    const paramsArr1 = paramsStr1.split("&")
    paramsArr = [...paramsArr, ...paramsArr1].filter(item => item)
    const params = {}
    const reg = /(\/?#\/.*)$/
    paramsArr.forEach(item => {
      const key = item.split("=")[0]
      let val = item.split("=")[1] || ""
      val = val.toString().replace(reg, "")
      params[key] = val
    })
    return params
}

export default getParamsFromUrl